import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import CollaboratorsEvaluateServices from "./collaboratorsEvaluate.services";
import { getPeriodicityByOrg } from "../Periodicity/actions";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getCollaboratorsEvaluate =
  (filters, setEmployeeSelected, codigo, anioActual) => async (dispatch) => {
    try {
      dispatch({
        type: actions.LOADER_COLLABORATORS_TO_EVALUATE,
        payload: true,
      });
      const resp = await CollaboratorsEvaluateServices.getCollaboratorsEvaluate(
        filters
      );
      if (codigo && resp.data.count > 0) {
        setEmployeeSelected(resp.data.data[0]);
        dispatch(
          getPeriodicityByOrg({
            tipo_busqueda: "empresa__id",
            filter: parseInt(resp.data.data[0].empresa),
            tipo_busqueda_2: "clasificacion_id",
            filter_2: parseInt(resp.data.data[0].clasificacion_empleado_id),
            tipo_busqueda_3: "anio",
            filter_3: anioActual,
          })
        );
      } else {
        setEmployeeSelected(null);
      }
      dispatch({
        type: actions.GET_COLLABORATORS_TO_EVALUATE,
        payload: resp.data,
      });
      dispatch({
        type: actions.COLLABORATORS_TO_EVALUATE_FAIL,
        payload: null,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data.mensaje;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            case 403:
              if (ex.response.data && ex.response.data.detail) {
                message = ex.response.data.detail;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.COLLABORATORS_TO_EVALUATE_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADER_COLLABORATORS_TO_EVALUATE,
        payload: false,
      });
    }
  };

export const getCollaboratorsEvaluateGeneral =
  (filters) => async (dispatch) => {
    try {
      dispatch({
        type: actions.LOADER_COLLABORATORS_TO_EVALUATE_GENERAL,
        payload: true,
      });
      const resp =
        await CollaboratorsEvaluateServices.getCollaboratorToEvaluateGeneral(
          filters
        );
      dispatch({
        type: actions.GET_COLLABORATORS_TO_EVALUATE_GENERAL,
        payload: resp.data,
      });
      dispatch({
        type: actions.COLLABORATORS_TO_EVALUATE_FAIL_GENERAL,
        payload: null,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data.mensaje;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            case 403:
              if (ex.response.data && ex.response.data.detail) {
                message = ex.response.data.detail;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.COLLABORATORS_TO_EVALUATE_FAIL_GENERAL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADER_COLLABORATORS_TO_EVALUATE_GENERAL,
        payload: false,
      });
    }
  };

export const getEvaluators = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_EVALUATORS,
      payload: true,
    });
    const resp = await CollaboratorsEvaluateServices.getEvaluators(filters);
    dispatch({
      type: actions.GET_EVALUATORS,
      payload: resp.data,
    });
    dispatch({
      type: actions.EVALUATORS_FAIL,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data && ex.response.data[0]) {
              message = ex.response.data[0];
            } else {
              message = messages.errorMessage;
            }
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.EVALUATORS_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_EVALUATORS,
      payload: false,
    });
  }
};

export const getPeriod = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_PERIOD,
      payload: true,
    });
    const resp = await CollaboratorsEvaluateServices.getPeriod(filters);
    dispatch({
      type: actions.GET_PERIOD,
      payload: resp.data,
    });
    dispatch({
      type: actions.PERIOD_FAIL,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else if (ex.response.data && ex.response.data.length > 0) {
              dispatch({
                type: actions.GET_PERIOD,
                payload: {data:[],count:0},
              });
              message = ex.response.data[0];
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.PERIOD_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_PERIOD,
      payload: false,
    });
  }
};

export const resetEvaluators = () => async (dispatch) => {
  dispatch({
    type: actions.GET_EVALUATORS,
    payload: { data: [], count: 0 },
  });
  dispatch({
    type: actions.EVALUATORS_FAIL,
    payload: null,
  });
};

export const resetPeriods = () => async (dispatch) => {
  dispatch({
    type: actions.GET_PERIOD,
    payload: { data: [], count: 0 },
  });
  dispatch({
    type: actions.PERIOD_FAIL,
    payload: null,
  });
};

export const deleteCollaboratorsEvaluateGeneral =
  (id, index) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADER_COLLABORATORS_TO_EVALUATE_GENERAL,
        payload: true,
      });
      await CollaboratorsEvaluateServices.deleteCollaboratorsEvaluateGeneral(
        id
      );
      const { data, count } =
        getState().collaboratorsEvaluate.collaboratorsEvaluateGeneral;
      let _data = data.slice();
      _data.splice(index, 1);
      dispatch({
        type: actions.GET_COLLABORATORS_TO_EVALUATE_GENERAL,
        payload: {
          data: _data,
          count: count - 1,
        },
      });
      dispatch({
        type: actions.COLLABORATORS_TO_EVALUATE_FAIL_GENERAL,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if(ex.response.data&&ex.response.data[0]){
                message = ex.response.data[0]
              }else{
                message = ex.response.data.mensaje;
              }
              break;

            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.COLLABORATORS_TO_EVALUATE_FAIL_GENERAL,
        payload: message,
      });
      toastr.error(message)
    } finally {
      dispatch({
        type: actions.LOADER_COLLABORATORS_TO_EVALUATE_GENERAL,
        payload: false,
      });
    }
  };

export const editCollaboratorsEvaluateGeneral =
  (req, index, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADER_COLLABORATORS_TO_EVALUATE_GENERAL,
        payload: true,
      });
      const resp =
        await CollaboratorsEvaluateServices.editCollaboratorsEvaluateGeneral(
          req.id,
          req
        );
      const { data, count } =
        getState().collaboratorsEvaluate.collaboratorsEvaluateGeneral;
      let _data = data.slice();
      _data[index] = resp.data;
      dispatch({
        type: actions.GET_COLLABORATORS_TO_EVALUATE_GENERAL,
        payload: {
          data: _data,
          count: count,
        },
      });
      dispatch({
        type: actions.FORM_COLLABORATORS_TO_EVALUATE_FAIL_GENERAL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data.mensaje;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.COLLABORATORS_TO_EVALUATE_FAIL_GENERAL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADER_COLLABORATORS_TO_EVALUATE_GENERAL,
        payload: false,
      });
    }
  };

export const editEvaluators =
  (req, index, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADER_EVALUATORS,
        payload: true,
      });
      const resp = await CollaboratorsEvaluateServices.editEvaluators(
        req.id,
        req
      );
      const { data, count } = getState().collaboratorsEvaluate.evaluators;
      let _data = data.slice();
      _data[index] = resp.data;
      dispatch({
        type: actions.GET_EVALUATORS,
        payload: {
          data: _data,
          count: count,
        },
      });
      dispatch({
        type: actions.FORM_EVALUATORS_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data.mensaje;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.EVALUATORS_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADER_EVALUATORS,
        payload: false,
      });
    }
  };

export const saveCollaboratorsEvaluateGeneral =
  (req, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADER_COLLABORATORS_TO_EVALUATE_GENERAL,
        payload: true,
      });
      const resp =
        await CollaboratorsEvaluateServices.saveCollaboratorsEvaluateGeneral(
          req
        );
      const { data, count } =
        getState().collaboratorsEvaluate.collaboratorsEvaluateGeneral;
      dispatch({
        type: actions.GET_COLLABORATORS_TO_EVALUATE_GENERAL,
        payload: {
          count: count + 1,
          data: [...data, resp.data],
        },
      });
      dispatch({
        type: actions.FORM_COLLABORATORS_TO_EVALUATE_FAIL_GENERAL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              if (ex.response.data && ex.response.data.detail) {
                message = ex.response.data.detail;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_COLLABORATORS_TO_EVALUATE_FAIL_GENERAL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADER_COLLABORATORS_TO_EVALUATE_GENERAL,
        payload: false,
      });
    }
  };

export const saveEvaluators =
  (req, handleClose, setEvaluador, index) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADER_EVALUATORS,
        payload: true,
      });
      const resp = await CollaboratorsEvaluateServices.saveEvaluators(req);
      const { data, count } =
        getState().collaboratorsEvaluate.collaboratorsEvaluateGeneral;
      data[index].lista_evaluador = resp.data.data;
      data[index].estado = resp.data.estado;
      dispatch({
        type: actions.GET_COLLABORATORS_TO_EVALUATE_GENERAL,
        payload: {
          count: count,
          data: data,
        },
      });
      // dispatch({
      //   type: actions.GET_EVALUATORS,
      //   payload:
      // });
      dispatch({
        type: actions.FORM_EVALUATORS_FAIL,
        payload: "",
      });
      handleClose();
      setEvaluador([]);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              if (ex.response.data && ex.response.data.detail) {
                message = ex.response.data.detail;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_EVALUATORS_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADER_EVALUATORS,
        payload: false,
      });
    }
  };
